module.exports = __webpack_public_path__ + "static/media/04-galeria-05-restaurante-palacio-mobile@2x.f296037d.jpg";